import { LegalRepresentativePayload, SubdelegatedRegistrationPayload } from 'models/interface/subdelegated'

import { LegalRepresentativeValues, SubdelegatedRegistrationFormValues } from './form.model'

const toIsoDate = (birthDate: string): string => {
  const [day, month, year] = birthDate.split('/')
  return `${year}-${month}-${day}`
}

const mapLegalRepresentative = (representative: LegalRepresentativeValues): LegalRepresentativePayload => ({
  fullName: representative.nome,
  cpf: representative.cpf,
  birthDate: toIsoDate(representative.dataNascimento),
  email: representative.email
})

export const mapFormValuesToPayload = (values: SubdelegatedRegistrationFormValues): SubdelegatedRegistrationPayload => {
  const jointSignature = values.assinaturaConjunta === 'SIM'

  return {
    fullName: values.nomeCompleto,
    email: values.email,
    phoneNumber: `+55 ${values.telefone}`,
    zipCode: values.cep,
    lpDocument: values.cnpj,
    corporateName: values.razaoSocial,
    tradeName: values.nomeFantasia,
    cnae: values.cnae,
    jointSignature,
    representative1: mapLegalRepresentative(values.representanteLegal1),
    ...(jointSignature && { representative2: mapLegalRepresentative(values.representanteLegal2) })
  }
}
